// Formato, opciones y estilos compartidos de Flujo de caja.
import type { Categoria, TipoCuenta } from './types';

export const TIPOS_CUENTA: { value: TipoCuenta; label: string }[] = [
  { value: 'banco', label: 'Banco' }, { value: 'caja', label: 'Caja' }, { value: 'mercadopago', label: 'MercadoPago' },
];
export const CATEGORIAS: { value: Categoria; label: string }[] = [
  { value: 'sueldos', label: 'Sueldos' }, { value: 'alquiler', label: 'Alquiler' }, { value: 'servicios', label: 'Servicios' },
  { value: 'impuestos', label: 'Impuestos' }, { value: 'otros', label: 'Otros' },
];

export const pesos = (n: number) => `$${Number(n).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const pesosCorto = (n: number) => `${n < 0 ? '−' : ''}$${Math.abs(Math.round(n)).toLocaleString('es-AR')}`;
export const fechaCorta = (iso: string) => iso.slice(0, 10).split('-').reverse().join('/');
export const diaMes = (iso: string) => fechaCorta(iso).slice(0, 5);
/** Hoy en Argentina (UTC−3), AAAA-MM-DD. */
export const hoyAR = () => new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString().slice(0, 10);
export const etiquetaTipo = (t: string) => TIPOS_CUENTA.find(x => x.value === t)?.label ?? t;
export const etiquetaCategoria = (c: string) => CATEGORIAS.find(x => x.value === c)?.label ?? c;
export const inputCls = 'w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-brand-500';
